import React from 'react';
import { StarIcon } from 'lucide-react';
import { QUICK_QUOTES } from '../data/testimonials';
export function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} aria-label="5 out of 5 stars" data-id="element-201" data-mp="2zqr1b3fm2ywd">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3 w-3 fill-mustard text-mustard" aria-hidden="true" data-id="element-202" data-mp="34plgzwia87c9" />)}
    </div>;
}
export function QuickTestimonials() {
  return <section aria-label="Teacher quotes" className="w-full bg-cream px-4 py-7" data-id="element-203" data-mp="2pze7w7e600o8">
      <div className="mx-auto grid max-w-5xl gap-2 md:grid-cols-3" data-id="element-204" data-mp="2usph2f6g8tjb">
        {QUICK_QUOTES.map((item, index) => <figure key={index} className="flex flex-col rounded-xl border border-night/10 bg-white p-3" data-id="element-205" data-mp="2h1all8vcuzvd" data-mpi={index}>
            <Stars data-id="element-206" data-mp="2l2nslma6p93v" />
            <blockquote className="mt-1.5 text-[12px] leading-snug text-night/80" data-id="element-207" data-mp="2l248q00z4an7">
              “{item.quote}”
            </blockquote>
          </figure>)}
      </div>
    </section>;
}